"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5843],{

/***/ 18802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ EMPTY_ARRAY; }
/* harmony export */ });
var EMPTY_ARRAY = [];


/***/ }),

/***/ 80352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export SkuPresentation */
/* harmony import */ var _Card_tsx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54353);
// Generated by ReScript, PLEASE EDIT WITH CARE

var make = _Card_tsx__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z;
var SkuPresentation;
 /* make Not a pure module */ 


/***/ }),

/***/ 54353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29815);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97133);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _prezzee_ribbon_src_components_common_Tag_Tag_gen__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88795);
/* harmony import */ var contexts_LayoutDataContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25149);
/* harmony import */ var components_CardZoomAnimation_bs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12054);
/* harmony import */ var components_library_CardStyles_bs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(70279);
/* harmony import */ var css_theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55374);
/* harmony import */ var bindings_Segment_bs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73840);
/* harmony import */ var common_utils_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(53782);
/* harmony import */ var components_CmsImage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73450);
/* harmony import */ var common_utils_array__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(18802);














var style = {
    soldOutLabel: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("position:absolute;right:0;top:0;border-bottom-left-radius:8px;border-top-right-radius:8px;background-color:", css_theme__WEBPACK_IMPORTED_MODULE_6__/* .Color.Red50 */ .Il.Red50, ";color:#ed0b09;z-index:1;text-align:center;padding:2px 10px 4px;font-size:14px;line-height:22px;min-width:40%;"),
    cardZoomAnimation: function(isSoldOut) {
        return /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("position:", isSoldOut ? "relative" : "static", ";");
    },
    tagline: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("margin:0 12px 12px;@media (min-width:768px){margin-left:16px;margin-right:16px;}"),
    innerContainer: function(isSoldOut) {
        return /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("opacity:", isSoldOut ? 0.4 : 1.0, ";position:relative;border-radius:8px;box-shadow:0 10px 30px rgba(209,213,223,50%);background-color:", css_theme__WEBPACK_IMPORTED_MODULE_6__/* .Color.White */ .Il.White, ";overflow-y:hidden;min-height:177px;@media (min-width:410px) and (max-width:624px){min-height:225px;}@media (min-width:625px) and (max-width:752px){min-height:284px;}@media (min-width:753px) and (max-width:1439px){min-height:247px;}@media (min-width:1440px){min-height:257px;}& > a{cursor:pointer;}");
    }
};
var PROMO_ICON = {
    src: __webpack_require__(92441),
    alt: "Promo icon",
    width: 30,
    height: 79
};
var desktopMd = "(max-width: 1440px)";
var desktopSm = "(max-width: 1225px)";
var tablet = "(max-width: 768px)";
var mobileLg = "(max-width: 640px)";
var CardContent = function(param) {
    var children = param.children, onClick = param.onClick, card = param.card, position = param.position;
    if (onClick) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("a", {
            onClick: onClick,
            children: children
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/store/".concat(card.slug),
        prefetch: false,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("a", {
            onClick: function() {
                (0,bindings_Segment_bs__WEBPACK_IMPORTED_MODULE_7__/* .productClicked */ .rC)((0,bindings_Segment_bs__WEBPACK_IMPORTED_MODULE_7__/* .cardToProductWithIndex */ .bC)(position, card));
            },
            children: children
        })
    });
};
var Card = function(param) {
    var skuDict = param.skuDict, card = param.card, position = param.position, onClick = param.onClick, _inGrid = param.inGrid, inGrid = _inGrid === void 0 ? true : _inGrid;
    var ref;
    var layoutData = (0,contexts_LayoutDataContext__WEBPACK_IMPORTED_MODULE_4__/* .useLayoutData */ .Q)();
    var soldOutBadgeText = (layoutData === null || layoutData === void 0 ? void 0 : layoutData.soldOutBadgeText) || common_utils_string__WEBPACK_IMPORTED_MODULE_10__/* .EMPTY_STRING */ .v6;
    // NOTE: The check is required for type compatibility with Rescript
    var skuDictArray = Array.isArray(skuDict) ? skuDict : common_utils_array__WEBPACK_IMPORTED_MODULE_11__/* .EMPTY_ARRAY */ .L;
    var hasPromos = Boolean(card.promos.length);
    var skuData = Object.fromEntries(skuDictArray)[card.cmsId];
    var isSoldOut = (skuData === null || skuData === void 0 ? void 0 : skuData.soldOut) || false;
    var imageUrl = skuData ? ((ref = skuData.themes[0]) === null || ref === void 0 ? void 0 : ref.image.url) || card.imgUrl : card.imgUrl;
    var soldOutLabel = /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: style.soldOutLabel,
        children: soldOutBadgeText
    });
    var onClickHandler = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if (isSoldOut) {
            return function(e) {
                return e.preventDefault();
            };
        }
        return onClick;
    }, [
        isSoldOut
    ]);
    var applyGridStyles = function(className) {
        if (inGrid) {
            return _emotion_css__WEBPACK_IMPORTED_MODULE_1__.cx.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(className));
        }
        return common_utils_string__WEBPACK_IMPORTED_MODULE_10__/* .EMPTY_STRING */ .v6;
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: applyGridStyles([
            components_library_CardStyles_bs__WEBPACK_IMPORTED_MODULE_13__/* .rootContainer */ .$2
        ]),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(components_CardZoomAnimation_bs__WEBPACK_IMPORTED_MODULE_5__/* .make */ .S, {
            className: style.cardZoomAnimation(isSoldOut),
            children: [
                isSoldOut ? soldOutLabel : null,
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                    className: style.innerContainer(isSoldOut),
                    children: [
                        hasPromos ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_CmsImage__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            className: "absolute z-10 top-0 left-0",
                            alt: PROMO_ICON.alt,
                            src: PROMO_ICON.src,
                            width: PROMO_ICON.width,
                            height: PROMO_ICON.height
                        }) : null,
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(CardContent, {
                            card: card,
                            position: position,
                            onClick: onClickHandler(),
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                                    className: "block",
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                                        className: "ratio-box fade-box",
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_CmsImage__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            alt: card.name,
                                            src: imageUrl,
                                            className: components_library_CardStyles_bs__WEBPACK_IMPORTED_MODULE_13__/* .cardImg */ .pU,
                                            width: 256,
                                            height: 159,
                                            sizes: "".concat(mobileLg, " 47vw, ").concat(tablet, " 304px, ").concat(desktopSm, " 240px, ").concat(desktopMd, " 224px, 256px")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("h3", {
                                    className: applyGridStyles([
                                        components_library_CardStyles_bs__WEBPACK_IMPORTED_MODULE_13__/* .cardName */ .ul,
                                        "font-semibold text-sm leading-4 sm:text-17px sm:leading-5 px-3 md:px-4 my-2", 
                                    ]),
                                    children: card.isSwappable ? card.displayName : card.name
                                }),
                                card.tagline ? // @ts-ignore
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_prezzee_ribbon_src_components_common_Tag_Tag_gen__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                                    className: style.tagline,
                                    children: card.tagline
                                }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
                                    className: applyGridStyles([
                                        components_library_CardStyles_bs__WEBPACK_IMPORTED_MODULE_13__/* .cardPrice */ .Cr,
                                        "text-mid-gray px-3 md:px-4 text-xs sm:text-sm leading-4 pb-3"
                                    ]),
                                    children: card.priceRange
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Card);


/***/ }),

/***/ 25843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I2": function() { return /* binding */ SimilarResults; },
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "We": function() { return /* binding */ getCardLists; },
/* harmony export */   "pj": function() { return /* binding */ spaceSlashRegex; }
/* harmony export */ });
/* unused harmony exports SkuPresentation, Styles */
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(20859);
/* harmony import */ var _Card_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80352);
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92592);
/* harmony import */ var _utils_Regex_bs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7618);
/* harmony import */ var _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99813);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(25400);
/* harmony import */ var _pages_business_CatalogueCardList_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63873);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
/* harmony import */ var _pages_business_CatalogueCardsSection_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41860);
/* harmony import */ var _pages_business_CatalogueCobrandedSection_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51769);
// Generated by ReScript, PLEASE EDIT WITH CARE













var smallTitle = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_7__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(1.5)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(2.0)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(1.0)),
            tl: /* [] */ 0
        }
    }
});
var bottomContainer = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_7__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(1.0)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("flex"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexDirection */ .Me8("row"),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexWrap */ .WOS("wrap"),
                tl: /* [] */ 0
            }
        }
    }
});
var Styles = {
    smallTitle: smallTitle,
    bottomContainer: bottomContainer
};
var spaceSlashRegex = /[\s\\]/g;
function getCardLists(search, cards) {
    return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_8__/* .mapWithDefault */ .k7(search, {
        filteredCards: cards,
        similarCards: []
    }, function(str) {
        var s = new RegExp(_rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_2__/* .lowercase_ascii */ .uq(str.replace(_utils_Regex_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .specialRegex */ .$I, "").replace(spaceSlashRegex, "")));
        return {
            filteredCards: _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_10__/* .keep */ .Cn(cards, function(c) {
                return s.test(_rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_2__/* .lowercase_ascii */ .uq(c.searchableTerms.replace(_utils_Regex_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .specialRegex */ .$I, "").replace(spaceSlashRegex, "")));
            }),
            similarCards: _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_10__/* .keep */ .Cn(cards, function(c) {
                return s.test(_rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_2__/* .lowercase_ascii */ .uq(c.similarTerms.replace(_utils_Regex_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .specialRegex */ .$I, "").replace(spaceSlashRegex, "")));
            })
        };
    });
}
function CardSearchResults$SimilarResults(props) {
    var cardLists = props.cardLists;
    if (!(cardLists.filteredCards.length !== 0 && cardLists.similarCards.length !== 0)) {
        return null;
    }
    var skuDict = props.skuDict;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("h3", {
                children: "Similar results",
                className: smallTitle
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("div", {
                children: _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_10__/* .mapWithIndex */ .Su(cardLists.similarCards, function(i, card) {
                    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_Card_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .make */ .S, {
                        card: card,
                        position: i + 1 | 0,
                        skuDict: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_11__/* .some */ .G(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_8__/* .getWithDefault */ .tj(skuDict, {}))
                    }, card.uid);
                }),
                className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_12__/* .make */ .S([
                    _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_8__/* .getWithDefault */ .tj(props.className, ""),
                    bottomContainer
                ])
            })
        ]
    });
}
var SimilarResults = {
    make: CardSearchResults$SimilarResults
};
function CardSearchResults(props) {
    var skuDict = props.skuDict;
    var cardLists = props.cardLists;
    if (cardLists.filteredCards.length !== 0) {
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
            children: [
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("h2", {
                    children: "Your search results",
                    className: _pages_business_CatalogueCardsSection_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .Styles.title */ .z0.title
                }),
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_pages_business_CatalogueCardList_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .Sy, {
                    catalogue: cardLists.filteredCards,
                    skuDict: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_11__/* .some */ .G(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_8__/* .getWithDefault */ .tj(skuDict, {}))
                }),
                cardLists.similarCards.length !== 0 ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(CardSearchResults$SimilarResults, {
                    cardLists: cardLists,
                    className: _pages_business_CatalogueCardList_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Styles.container */ .z0.container
                }) : null
            ]
        });
    } else {
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_pages_business_CatalogueCobrandedSection_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .make */ .Sy, {
            catalogue: props.swappableCards,
            isSearch: true,
            skuDict: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_11__/* .some */ .G(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_8__/* .getWithDefault */ .tj(skuDict, {}))
        });
    }
}
var SkuPresentation;
var make = CardSearchResults;
 /* smallTitle Not a pure module */ 


/***/ }),

/***/ 70279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rootContainer; },
/* harmony export */   "Cr": function() { return /* binding */ cardPrice; },
/* harmony export */   "Uj": function() { return /* binding */ gridContainer; },
/* harmony export */   "pU": function() { return /* binding */ cardImg; },
/* harmony export */   "ul": function() { return /* binding */ cardName; }
/* harmony export */ });
/* unused harmony export innerContainer */
// Generated by ReScript, PLEASE EDIT WITH CARE
var rootContainer = "my-4 md:my-4 lg:px-2 w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5";
var gridContainer = "my-4 md:my-4 px-2 w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5";
var innerContainer = "relative overflow-hidden rounded-lg shadow-lg bg-white";
var cardImg = "block h-full w-full";
var cardName = "font-semibold text-sm leading-4 sm:text-17px sm:leading-5 px-3 md:px-4 my-2";
var cardPrice = "text-mid-gray px-3 md:px-4 text-xs sm:text-sm leading-4 pb-3";
 /* No side effect */ 


/***/ }),

/***/ 63873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z0": function() { return /* binding */ CatalogueCardList_bs_Styles; },
  "Sy": function() { return /* binding */ CatalogueCardList_bs_make; }
});

// UNUSED EXPORTS: SkuPresentation

// EXTERNAL MODULE: ./src/bindings/BsCss.bs.js + 1 modules
var BsCss_bs = __webpack_require__(71863);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Array.js
var belt_Array = __webpack_require__(96533);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_option.js
var caml_option = __webpack_require__(25400);
// EXTERNAL MODULE: ./src/components/library/Card.bs.js
var Card_bs = __webpack_require__(80352);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/bs-css/src/Css_Legacy_Core.bs.js
var Css_Legacy_Core_bs = __webpack_require__(68364);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Modal/Modal.bs.js
var Modal_bs = __webpack_require__(50952);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Button/Button.bs.js + 1 modules
var Button_bs = __webpack_require__(10573);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Modal/Modal__Close.bs.js
var Modal_Close_bs = __webpack_require__(78804);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Color.bs.js
var Theme_Color_bs = __webpack_require__(17845);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Modal/Modal__Container.bs.js + 1 modules
var Modal_Container_bs = __webpack_require__(95157);
;// CONCATENATED MODULE: ./src/components/pages/business/CatalogueModal.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE











var buttonColour_0 = Theme_Color_bs/* Common.prezzeeRed */.Gn.prezzeeRed;
var buttonColour_1 = Theme_Color_bs/* Business.white */.e.white;
var buttonColour_2 = Theme_Color_bs/* Common.darkRed */.Gn.darkRed;
var buttonColour = /* Custom */ {
    _0: buttonColour_0,
    _1: buttonColour_1,
    _2: buttonColour_2
};
var modalContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs.px(387)),
    tl: {
        hd: BsCss_bs/* outline */.Kl7(BsCss_bs.px(1), "solid", "transparent"),
        tl: /* [] */ 0
    }
});
var modalInnerContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* backgroundColor */.Czw(Theme_Color_bs/* Common.white */.Gn.white),
    tl: {
        hd: BsCss_bs/* boxShadow */.Wnp(Css_Legacy_Core_bs/* Shadow.box */.jXB.box(BsCss_bs.px(0), BsCss_bs.px(40), BsCss_bs.px(200), undefined, undefined, BsCss_bs/* rgba */.m4f(0, 0, 0, BsCss_bs/* pct */.hdZ(8)))),
        tl: {
            hd: BsCss_bs/* borderRadius */.E0l(BsCss_bs.px(4)),
            tl: {
                hd: BsCss_bs/* textAlign */.ydu("center"),
                tl: {
                    hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(50)),
                    tl: {
                        hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(30)),
                        tl: /* [] */ 0
                    }
                }
            }
        }
    }
});
var modalHeading = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(28)),
    tl: {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(42)),
        tl: {
            hd: BsCss_bs/* fontWeight */.Ue2({
                NAME: "num",
                VAL: 600
            }),
            tl: {
                hd: BsCss_bs/* color */.$_Y(Theme_Color_bs/* Business.charcoal */.e.charcoal),
                tl: /* [] */ 0
            }
        }
    }
});
var modalText = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs.px(16)),
    tl: {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs.px(24)),
        tl: {
            hd: BsCss_bs/* fontWeight */.Ue2({
                NAME: "num",
                VAL: 400
            }),
            tl: {
                hd: BsCss_bs/* paddingTop */.odA(BsCss_bs.px(18)),
                tl: {
                    hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs.px(22)),
                    tl: {
                        hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(70)),
                        tl: {
                            hd: BsCss_bs/* margin */.e6$("auto"),
                            tl: {
                                hd: BsCss_bs/* color */.$_Y(Theme_Color_bs/* Business.bodyTextGrey */.e.bodyTextGrey),
                                tl: /* [] */ 0
                            }
                        }
                    }
                }
            }
        }
    }
});
var modalButton = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("block"),
    tl: {
        hd: BsCss_bs/* margin */.e6$("auto"),
        tl: {
            hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(90)),
            tl: /* [] */ 0
        }
    }
});
var modalLink = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* textDecoration */.QXS("underline"),
    tl: /* [] */ 0
});
var modalClose = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* important */.efO(BsCss_bs/* background */.Oq0(BsCss_bs/* hex */.$v1("EBEBEB"))),
    tl: {
        hd: BsCss_bs/* important */.efO(BsCss_bs/* right */.F2z(BsCss_bs.px(11))),
        tl: {
            hd: BsCss_bs/* important */.efO(BsCss_bs/* top */.wey(BsCss_bs.px(11))),
            tl: {
                hd: BsCss_bs/* important */.efO(BsCss_bs/* fontSize */.JBY(BsCss_bs.px(20))),
                tl: {
                    hd: BsCss_bs/* borderRadius */.E0l(BsCss_bs/* pct */.hdZ(50)),
                    tl: {
                        hd: BsCss_bs/* width */.bf$(BsCss_bs.px(30)),
                        tl: {
                            hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(30)),
                            tl: {
                                hd: BsCss_bs/* important */.efO(BsCss_bs/* color */.$_Y(BsCss_bs/* hex */.$v1("444444"))),
                                tl: {
                                    hd: BsCss_bs/* display */.jfB("flex"),
                                    tl: {
                                        hd: BsCss_bs/* justifyContent */.KlP("center"),
                                        tl: {
                                            hd: BsCss_bs/* alignItems */.cq$("center"),
                                            tl: /* [] */ 0
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});
var Styles = {
    modalContainer: modalContainer,
    modalInnerContainer: modalInnerContainer,
    modalHeading: modalHeading,
    modalText: modalText,
    modalButton: modalButton,
    modalLink: modalLink,
    modalClose: modalClose
};
var content = jsx_runtime.jsx(react.Fragment, {
    children: jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx("h2", {
                children: "Start gifting today!",
                className: modalHeading
            }),
            jsx_runtime.jsx("p", {
                children: "Sign up to Prezzee Business to start purchasing your gift cards.",
                className: modalText
            }),
            jsx_runtime.jsx(Button_bs.make, {
                children: jsx_runtime.jsx((link_default()), {
                    href: "/business/register/",
                    prefetch: false,
                    children: jsx_runtime.jsx("button", {
                        children: "Create an account",
                        className: modalButton
                    })
                }),
                colour: /* BusinessPurple */ 3,
                variant: /* Small */ 1
            }),
            jsx_runtime.jsx(Button_bs.make, {
                children: jsx_runtime.jsx((link_default()), {
                    href: "/business/signin/",
                    prefetch: false,
                    children: jsx_runtime.jsx("button", {
                        children: "Or, log in here",
                        className: modalLink
                    })
                }),
                fill: /* None */ 2,
                colour: buttonColour
            })
        ],
        className: modalInnerContainer
    })
});
var ModalContent = {
    content: content
};
function CatalogueModal(props) {
    var onRequestClose = props.onRequestClose;
    return jsx_runtime.jsx(Modal_bs.make, {
        children: jsx_runtime.jsxs(Modal_Container_bs.make, {
            id: "modal-container",
            isOpen: props.modalOpen,
            onRequestClose: onRequestClose,
            children: [
                jsx_runtime.jsx(Modal_Close_bs/* make */.S, {
                    className: modalClose,
                    closeFunc: function closeFunc(param) {
                        curry._1(onRequestClose, undefined);
                    }
                }),
                content
            ],
            borderless: true,
            className: modalContainer
        })
    });
}
var Link$1;
var make = CatalogueModal;
 /* modalContainer Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/business/CatalogueCard.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE







function CatalogueCard(props) {
    var card = props.card;
    var match = react.useState(function() {
        return false;
    });
    var setModalOpen = match[1];
    var onRequestClose = function onRequestClose(param) {
        curry._1(setModalOpen, function(param) {
            return false;
        });
    };
    var openFunc = function openFunc(param) {
        curry._1(setModalOpen, function(param) {
            return true;
        });
    };
    return jsx_runtime.jsxs(jsx_runtime.Fragment, {
        children: [
            jsx_runtime.jsx(Card_bs/* make */.S, {
                card: card,
                position: props.position,
                skuDict: caml_option/* some */.G(belt_Option/* getWithDefault */.tj(props.skuDict, {})),
                onClick: openFunc
            }, "eGifCard_" + card.uid),
            jsx_runtime.jsx(make, {
                modalOpen: match[0],
                onRequestClose: onRequestClose
            })
        ]
    });
}
var SkuPresentation;
var CatalogueCard_bs_make = CatalogueCard;
 /* Card Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/business/CatalogueCardList.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE







var title = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs/* rem */.hOB(1.5)),
    tl: {
        hd: BsCss_bs/* fontWeight */.Ue2({
            NAME: "num",
            VAL: 600
        }),
        tl: {
            hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs/* rem */.hOB(1.0)),
            tl: /* [] */ 0
        }
    }
});
var subTitle = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs/* rem */.hOB(56.0)),
    tl: /* [] */ 0
});
var container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("flex"),
    tl: {
        hd: BsCss_bs/* flexWrap */.WOS("wrap"),
        tl: {
            hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs/* rem */.hOB(-0.5)),
            tl: {
                hd: BsCss_bs/* marginRight */.wzR(BsCss_bs/* rem */.hOB(-0.5)),
                tl: {
                    hd: BsCss_bs/* media */.BC2("(min-width: 1024px)", {
                        hd: BsCss_bs/* marginLeft */.oIA(BsCss_bs/* rem */.hOB(-1.0)),
                        tl: {
                            hd: BsCss_bs/* marginRight */.wzR(BsCss_bs/* rem */.hOB(-1.0)),
                            tl: /* [] */ 0
                        }
                    }),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var CatalogueCardList_bs_Styles = {
    title: title,
    subTitle: subTitle,
    container: container
};
function CatalogueCardList(props) {
    var skuDict = props.skuDict;
    return jsx_runtime.jsx("div", {
        children: belt_Array/* mapWithIndexU */.KK(props.catalogue, function(i, card) {
            return jsx_runtime.jsx(CatalogueCard_bs_make, {
                card: card,
                position: i + 1 | 0,
                skuDict: caml_option/* some */.G(belt_Option/* getWithDefault */.tj(skuDict, {}))
            }, "eGifCard_" + card.uid);
        }),
        className: container
    });
}
var CatalogueCardList_bs_SkuPresentation;
var CatalogueCardList_bs_make = CatalogueCardList;
 /* title Not a pure module */ 


/***/ }),

/***/ 41860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "z0": function() { return /* binding */ Styles; }
/* harmony export */ });
/* unused harmony export SkuPresentation */
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92592);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25400);
/* harmony import */ var _CatalogueCardList_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63873);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE







var container = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingTop */ .odA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.5)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .pct */ .hdZ(100.0)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingBottom */ .EtG(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.5)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2("(max-width: 768px)", {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingTop */ .odA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(0.5)),
                    tl: /* [] */ 0
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var title = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(2.0)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2({
            NAME: "num",
            VAL: 600
        }),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingBottom */ .EtG(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.0)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2("(max-width: 768px)", {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.5)),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingBottom */ .EtG(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(0.5)),
                        tl: /* [] */ 0
                    }
                }),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2("(max-width: 480px)", {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.25)),
                        tl: /* [] */ 0
                    }),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var Styles = {
    container: container,
    title: title
};
var make = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(function(props) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs("div", {
        children: [
            props.showTitle ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx("h2", {
                children: "Explore our eGift cards",
                className: title
            }) : null,
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_CatalogueCardList_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .Sy, {
                catalogue: props.catalogue,
                skuDict: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_5__/* .some */ .G(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_6__/* .getWithDefault */ .tj(props.skuDict, {}))
            })
        ],
        className: container
    });
});
var SkuPresentation;
 /* container Not a pure module */ 


/***/ }),

/***/ 51769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports SkuPresentation, Styles */
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92592);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25400);
/* harmony import */ var _CatalogueCardList_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63873);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE








function container(isSearch) {
    return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingTop */ .odA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.5)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .pct */ .hdZ(100.0)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2("(max-width: 768px)", {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingTop */ .odA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(0.5)),
                    tl: /* [] */ 0
                }),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingBottom */ .EtG(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(isSearch ? 1.5 : 0.0)),
                    tl: /* [] */ 0
                }
            }
        }
    });
}
var title = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.5)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2({
            NAME: "num",
            VAL: 600
        }),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingBottom */ .EtG(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.0)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2("(max-width: 480px)", {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.25)),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingBottom */ .EtG(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(0.5)),
                        tl: /* [] */ 0
                    }
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var subTitle = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .maxWidth */ .kkr(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(56.0)),
    tl: /* [] */ 0
});
var Styles = {
    container: container,
    title: title,
    subTitle: subTitle
};
var make = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(function(props) {
    var isSearch = props.isSearch;
    var catalogue = props.catalogue;
    var isSearch$1 = isSearch !== undefined ? isSearch : false;
    var items = isSearch$1 ? _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_5__/* .keep */ .Cn(catalogue, function(s) {
        return s.slug === "prezzee-gift-card";
    }) : catalogue;
    if (items.length !== 0) {
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs("div", {
            children: [
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx("h2", {
                    children: isSearch$1 ? "Prezzee Smart eGift Cards" : "Co-branded gift options with endless choice",
                    className: title
                }),
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx("p", {
                    children: isSearch$1 ? "Your search has yielded no results. so why not consider the Prezzee Smart eGift Card which can be used to unlock our wall of retailer eGift Cards." : "A Smart eGift Card is the ultimate gift of choice for your business needs. One card, that can be co-branded with your company's logo, to be swapped for multiple eGift cards from hundreds of top brands.",
                    className: subTitle
                }),
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_CatalogueCardList_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .Sy, {
                    catalogue: items,
                    skuDict: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_6__/* .some */ .G(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_7__/* .getWithDefault */ .tj(props.skuDict, {}))
                })
            ],
            className: container(isSearch$1)
        });
    } else {
        return null;
    }
});
var SkuPresentation;
 /* title Not a pure module */ 


/***/ })

}]);